import { useState } from "react";
import { PINK } from "./salesShared";

/** Avatar client : vignette 64×64 de la photo d'identité du dossier (B2) sinon initiales colorées. */
export default function ClientAvatar({ client, size = 36, testId }) {
  const [broken, setBroken] = useState(false);
  const col = client?.color || {};
  const url = client?.photo_thumb_url && !broken ? `${process.env.REACT_APP_BACKEND_URL}${client.photo_thumb_url}` : null;
  return (
    <span className="relative inline-flex shrink-0" style={{ width: size, height: size }} data-testid={testId} data-photo={!!url}>
      {url
        ? <img src={url} alt="" onError={() => setBroken(true)} style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", border: "0.5px solid #3a3a42" }} />
        : <span className="inline-flex items-center justify-center" style={{ width: size, height: size, borderRadius: "50%", background: col.bg || "#1c1c22", color: col.fg || "#e8e8ec", fontSize: Math.round(size * 0.34), fontWeight: 700, border: `0.5px solid ${col.border || "#3a3a42"}` }}>{client?.initials || "?"}</span>}
      {client?.is_company && <span className="absolute" style={{ right: -4, bottom: -3, fontSize: 7.5, padding: "0 4px", borderRadius: 4, background: "#0e0e10", border: `0.5px solid ${PINK}`, color: PINK, fontWeight: 700, lineHeight: "11px" }}>SARL</span>}
    </span>
  );
}
